import { axiosClient } from './AxiosClient'

function listAllAdmin(page, size, companyId, status, type, searchKeyword, callback, errorCallback){
    const url = "/delivery/admin/list"
    const query = {
        page: page,
        size: size,
        building_id: localStorage.getItem('building_id')
    }
    if(companyId){
        query["company_id"] = companyId
    }
    if(status){
        query["status"] = status
    }
    if(type){
        query["type"] = type
    }
    if(searchKeyword){
        query["search_keyword"] = searchKeyword
    }

    axiosClient.get(url,{
        params: query
    })
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function createDelivery(
    trackingNo, 
    senderName, 
    senderAddress, 
    provider, 
    senderDate, 
    receiveDate, 
    type, 
    companyId,
    callback,
    errorCallback
){
    const url = "/delivery/create"
    var body = new FormData()
    body.append("tracking_no", trackingNo)
    body.append("sender_name", senderName)
    body.append("sender_address", senderAddress)
    body.append("provider", provider)
    body.append("sender_date", senderDate)
    body.append("receive_date", receiveDate)
    body.append("type", type)
    body.append("company_id", companyId)

    axiosClient.post(url, body)
    .then((response) => {
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

function editDelivery(
    deliveryId,
    trackingNo, 
    senderName, 
    senderAddress, 
    provider, 
    senderDate, 
    receiveDate, 
    type, 
    companyId,
    callback,
    errorCallback
){
    const url = "/delivery/edit"
    var body = new FormData()
    body.append("delivery_id", deliveryId)
    body.append("tracking_no", trackingNo)
    body.append("sender_name", senderName)
    body.append("sender_address", senderAddress)
    body.append("provider", provider)
    body.append("sender_date", senderDate)
    body.append("receive_date", receiveDate)
    body.append("type", type)
    body.append("company_id", companyId)

    axiosClient.post(url, body)
    .then((response) => {
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

function deliveryDetail(deliveryId, callback, errorCallback){
    const url = `/delivery/get/${deliveryId}`
    axiosClient.get(url)
    .then((response) => {
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

function listDeliveryTrack(deliveryId, callback, errorCallback){
    const url = '/delivery/delivery_track/list'
    const query = {
        delivery_id: deliveryId
    }
    axiosClient.get(url, {
        params: query
    })
    .then((response) => {
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

function createDeliveryTrack(deliveryId, deliveryDetail, remark, date, callback, errorCallback){
    const url = '/delivery/delivery_track/create'
    var body = new FormData()
    body.append("delivery_id", deliveryId)
    body.append("delivery_detail", deliveryDetail)
    body.append("remark", remark)
    body.append("date", date)

    axiosClient.post(url, body)
    .then((response) => {
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

function markAsDelivered(deliveryId, callback, errorCallback){
    const url = '/delivery/mark_as_delivered'
    var body = new FormData()
    body.append("delivery_id", deliveryId)

    axiosClient.post(url, body)
    .then((response) => {
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

function cancelDelivery(deliveryId, callback, errorCallback){
    const url = '/delivery/cancel_delivery'
    var body = new FormData()
    body.append("delivery_id", deliveryId)

    axiosClient.post(url, body)
    .then((response) => {
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

function deleteDelivery(deliveryId, callback, errorCallback){
    const url = '/delivery/delete'
    var body = new FormData()
    body.append("delivery_id", deliveryId)

    axiosClient.post(url, body)
    .then((response) => {
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

export {
    listAllAdmin,
    createDelivery,
    editDelivery,
    deliveryDetail,
    listDeliveryTrack,
    createDeliveryTrack,
    markAsDelivered,
    cancelDelivery,
    deleteDelivery
}